var scrollToTop = $(".scrollToTop");
//https://stackoverflow.com/a/19738288
var page = $("html, body");
var liveZillaButtonsPanel = $();
var liveZillaChat = $();
var liveZillaPointer = $();

scrollToTop.click(function () {
    page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function () {
        page.stop();
    });
    page.stop().animate(
        {
            scrollTop: $("body").offset().top
        },
        1e3,
        function () {
            page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
        }
    );
    return false;
});

function scrollDownFunction() {
    if ($(window).scrollTop() > 100) {
        scrollToTop.addClass("showScrollButton");
        liveZillaButtonsPanel.css("margin-bottom", "53px");
        liveZillaChat.css("margin-bottom", "53px");
        liveZillaPointer.css("margin-bottom", "50px");
    } else {
        scrollToTop.removeClass("showScrollButton");
        liveZillaButtonsPanel.css("margin-bottom", "3px");
        liveZillaChat.css("margin-bottom", "3px");
        liveZillaPointer.css("margin-bottom", "");
    }
}

window.onscroll = scrollDownFunction;

$(document).on('liveZillaLoaded', function() {
    liveZillaButtonsPanel = $("#lz_overlay_wm");
    liveZillaButtonsPanel.css("transition", "margin-bottom 0.5s ease-in");
    liveZillaChat = $("#lz_overlay_chat");
    liveZillaChat.css("transition", "margin-bottom 0.5s ease-in");
    liveZillaPointer = $('#lz_chat_overlay_pointer_h');
    liveZillaPointer.css("transition", "margin-bottom 0.5s ease-in");
    scrollDownFunction();
});
